<script>
export default {
  name: "FieldRulesMixin",
  computed: {
    rules() {
      const rules = []
      const max_length = this.fieldOption['max_length']
      const required = this.fieldOption['required']
      if (this.fieldOption.field_type && this.fieldOption.field_type === 'email') {
        const rule = value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
        rules.push(rule)
      }
      if (max_length) {
        const rule =
            value => (value || '').length <= max_length ||
                `A maximum of ${max_length} characters is allowed`
        rules.push(rule)
      }
      if (required) {
        const rule = value => !!value || 'Required.'
        rules.push(rule)
      }
      return rules
    },
  }
}
</script>

<style scoped>

</style>